// AI解析タブのデータ取得
import { ref, watch } from 'vue';

export const useAiAnalysis = ({ selectedItem, detailPlayerRef }) => {
  const aiAnalysisData = ref(null);
  const aiAnalysisLoading = ref(false);
  const aiAnalysisError = ref(null);

  const cache = {};
  const inflight = {};

  const fetchAiAnalysis = (videoId) => {
    if (cache[videoId]) {
      aiAnalysisData.value = cache[videoId];
      aiAnalysisError.value = null;
      return Promise.resolve();
    }
    // 取得中に別経路 (ジャンプ処理) から呼ばれても 1 本にまとめる
    if (inflight[videoId]) {
      return inflight[videoId];
    }

    aiAnalysisLoading.value = true;
    aiAnalysisError.value = null;
    aiAnalysisData.value = null;

    const request = (async () => {
      try {
        const response = await fetch(`/drive/emvd-ai/analysis/detail/${videoId}`, {
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
        });

        if (response.status === 404) {
          aiAnalysisError.value = '解析データが見つかりません';
          return;
        }

        if (!response.ok) {
          aiAnalysisError.value = '通信エラーが発生しました';
          return;
        }

        const data = await response.json();
        cache[videoId] = data;
        aiAnalysisData.value = data;
      } catch (error) {
        aiAnalysisError.value = '通信エラーが発生しました';
      } finally {
        aiAnalysisLoading.value = false;
        delete inflight[videoId];
      }
    })();

    inflight[videoId] = request;

    return request;
  };

  watch(selectedItem, (nextItem) => {
    if (nextItem && nextItem.ai_analysis_status === 'analyzed') {
      fetchAiAnalysis(nextItem.id);
    }
  });

  const formatSeconds = (sec) => {
    if (sec === null || sec === undefined) {
      return '';
    }
    const total = Math.trunc(Number(sec));
    if (!Number.isFinite(total)) {
      return '';
    }
    const minutes = Math.floor(total / 60);
    const seconds = total % 60;
    return `${minutes}:${String(seconds).padStart(2, '0')}`;
  };

  const sceneThumbnailPreviewUrl = ref(null);

  const openSceneThumbnailPreview = (url) => {
    if (!url) {
      return;
    }
    sceneThumbnailPreviewUrl.value = url;
    window.jQuery('#sceneThumbnailModal').modal('show');
  };

  const seekableKinds = ['video', 'audio'];

  const seekToTranscriptSegment = (segment) => {
    const item = selectedItem.value;
    const start = Number(segment?.start);

    if (
      !item ||
      !seekableKinds.includes(item.kind) ||
      !item.can_preview ||
      !item.manifest_url ||
      !Number.isFinite(start) ||
      start < 0
    ) {
      return;
    }

    detailPlayerRef.value?.seekTo(start);
  };

  return {
    aiAnalysisData,
    aiAnalysisLoading,
    aiAnalysisError,
    fetchAiAnalysis,
    formatSeconds,
    sceneThumbnailPreviewUrl,
    openSceneThumbnailPreview,
    seekToTranscriptSegment,
  };
};
